<template>
  <div class="gf-field-compound">
    <FormSelect :options="dbTypes" v-model="item.target" />
    <div class="gf-field" style="flex-grow: 2" v-if="!item.target">
      <input v-model="componentValue" :type="type || 'text'" :placeholder="placeholder" />
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../Form/FormCommon'

export default {
  props: ["placeholder", "type", "item"],
  mixins: [componentMixin],
  watch: {
    "item.target"() {
      this.componentValue=null;
    },
  },
  computed: {
    dataConfig() {
      return this.stores.config.config?.data;
    },
    dbTypes() {
      var result=[];
      for(var type in this.dataConfig || {}) {
        var typeData=this.dataConfig[type];
        if (typeData.hasPage) {
          result.push({
            text: typeData.title,
            value: type
          });
        }
      }
      return result;
    },
  },
}
</script>
